import jwtDecode from 'jwt-decode'

import {loginStorage} from './loginClasses'

/**
 * Returns the current logged-in user's id (the `user_id` JWT claim) synchronously.
 * This matches the value persisted by backend entities such as `uploadedByUserId`.
 */
export const getCurrentUserId = (): string | undefined => {
  try {
    const token = loginStorage.getToken()?.accessToken
    if (!token) {
      return undefined
    }

    const decoded = jwtDecode<{user_id?: string}>(token)
    return decoded?.user_id
  } catch {
    return undefined
  }
}
